export const TRANSACTION_TYPE_MAP = [
  "Full Tax",
  "Simplified Tax",
  "Self-billed",
  "Third-party",
  "Summary",
  "Continuous supply",
  "Export",
  "Deemed Supply",
  "Import of services (RCM)",
  "Profit margin",
  "Profit Margin Self",
  "E-commerce transaction",
  "Import of Goods",
  "Special Zone Supplies",
  "Prepayment"
];